var _path, _path2, _g, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHn = function SvgHn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.7h512v170.6H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hn_svg__c",
    fill: "#18c3df",
    transform: "translate(256 256)scale(28.44446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hn_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hn_svg__a",
    d: "m0-1-.3 1 .5.1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__c",
    width: "100%",
    height: "100%",
    transform: "translate(142.2 -45.5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__c",
    width: "100%",
    height: "100%",
    transform: "translate(142.2 39.8)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__c",
    width: "100%",
    height: "100%",
    transform: "translate(-142.2 -45.5)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn_svg__c",
    width: "100%",
    height: "100%",
    transform: "translate(-142.2 39.8)"
  })));
};
export default SvgHn;